import { Component, ChangeDetectionStrategy, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BlockConfig } from '@skyeng/libs/shared/blocks/core';

@Component({
  selector: 'sky-block-group',
  template: `
    <ng-content></ng-content>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BlockGroupComponent<TConfig extends object> implements OnChanges {
  @Input() config: TConfig;
  @Input() contentGroupId: string | undefined = undefined;

  private blockConfig = new BlockConfig<TConfig>();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.config) {
      this.blockConfig.set(this.config);
    }
  }

  getConfig(): BlockConfig<TConfig> {
    return this.blockConfig;
  }

  getContentGroupId(): string | undefined {
    return this.contentGroupId || undefined;
  }
}
